import React from 'react';
import { Button, Modal } from 'antd';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';

import { NO_CHOSEN_FILE_MESSAGE, WhiteButton } from '@components';
// import { NO_CHOSEN_FILE_MESSAGE, URL_REGEX_MORE } from '@utils';

import './style.scss';
import { BlueButton } from '@share/components';

interface IState {
  url: string;
  imageName: string;
  file: any;
  invalidUrl: boolean;
  imageLoad: string;
}

interface IProps {
  visible: boolean;
  imageName: string;
  imageKey: string;
  titleKey?: string;
  url: string;
  onCancel: () => void;
  onSave: (url: string, file: any) => void;
}

export const URL_REGEX_MORE = /^(http[s]?:\/\/)(w{3,3}\.){0,1}[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]/;

export class ModalBanner extends React.Component<IProps, IState> {

  state: IState = { url: '', imageName: '', file: null, invalidUrl: false, imageLoad: '' };

  componentDidMount(): void {
    this.setState({ imageName: this.props.imageName });
    this.setState({ url: this.props.url });
  }

  handleSave = () => {
    if (!this.state.invalidUrl) {
      this.props.onSave(this.state.url, this.state.file);
    }
  }

  handleCance = () => {
    this.setState({ url: this.props.url, imageName: this.props.imageName, file: null });
    this.props.onCancel();
  }

  handlePhotoFile = (event: any) => {
    const file = event;
    this.setState({ imageName: event.target.files[0].name, file });
    this.handleUpload(event);
  };

  handleUrlChange = (event: any) => {
    const url = event.target.value.trim();
    this.setState({ url, invalidUrl: !isEmpty(url) && !URL_REGEX_MORE.test(url) });
  }

  handleUpload = (info: any) => {
    const file = info.target.files[0] as File;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.setState({ imageLoad: e?.target?.result as string });
    };
    reader.readAsDataURL(file);
  };

  render(): React.ReactNode {
    const { visible, imageKey, titleKey } = this.props;
    return (
      <Modal
        className="modal-banner"
        open={visible}
        footer={null}
        onCancel={this.handleCance}
        wrapClassName="modal-banner__wrapper"
      >
        <div>
          <h4 className="modal-banner__title">
            <FormattedMessage id={!isEmpty(titleKey) ? titleKey : 'add.modify.banner'} />
          </h4>
          <div className="modal-banner__content">
            <div className="add-menu-container">
              <div className="add-menu-fields">
                <div className="add-menu-field form-input-container">
                  <div className="add-menu-field-title">
                    <FormattedMessage id="modal.banner.image" />:
                  </div>
                  <div className="add-menu-field-input form-input-content">
                    <label htmlFor={`file_selector_${imageKey}`} className="file-upload"><FormattedMessage id="account.details.chose_file" /></label>
                    <label className="file-uploaded">{this.state.imageName}</label>
                    <input type="file" id={`file_selector_${imageKey}`} className="file-upload" onChange={event => this.handlePhotoFile(event)} />
                  </div>
                </div>

                {
                  this.state.imageLoad ?
                    <img
                      id="upload-preview"
                      src={this.state.imageLoad}
                      alt="upload"
                      style={{ objectFit: 'scale-down', maxHeight: '180px', height: '100%', width: 'auto' }}
                    />
                    : null
                }

                {/* <div className="add-menu-field form-input-container">
                  <div className="add-menu-field-title">
                    <FormattedMessage id="modal.banner.url" />:
                  </div>
                  <div className="add-menu-field-input form-input-content">
                    <input className="form-input" value={this.state.url} onChange={this.handleUrlChange} />
                    {this.state.invalidUrl && (<div className="add-menu-field-input__invalid"><FormattedMessage id="modal.banner.invalid" /></div>)}
                  </div>
                </div> */}
              </div>
            </div>

            <div className="modal-banner__buttons">
              <WhiteButton onClick={this.props.onCancel} >
                <FormattedMessage id="cancel.button" />
              </WhiteButton>
              <BlueButton onClick={this.handleSave} disabled={isEmpty(this.state.imageName) || !this.state.imageName || this.state.imageName === NO_CHOSEN_FILE_MESSAGE || this.state.invalidUrl}>
                <FormattedMessage id="apply" />
              </BlueButton>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
